// Types
import { CiiSimulatorFormValues } from '@schemas/forms';

/**
 * Transforms the provided `formValues` into a standardized state object.
 *
 * @param formValues - The form values from the CiiSimulator.
 *
 * @returns An object representing the state extracted and transformed from the form values.
 */
export const getStateFromFormValues = (formValues: CiiSimulatorFormValues) => ({
  ladenAverageSpeedKts: Number(formValues.ladenAvgSpeed),
  ballastAverageSpeedKts: Number(formValues.ballastAvgSpeed),
  averageDaysOfSailingPerMonth: Number(formValues.sailingDays),
  fuelTypeConversionFactor: formValues.fuelType.co2ConversionFactor,
  energyConversion: formValues.fuelType.energyConversion,
  averageBeaufort: Number(formValues.avgBeaufort),
  useUnderWaterCleaning: formValues.uwc,
  carbonCreditPricePerMT: Number(formValues.carbonPrice),
  fuelModes: formValues.fuelModes,
  defaultFuelPrice: Number(formValues.fuelPrice),
  defaultFuelType: formValues.fuelType,
  bulkFuelType: formValues.bulkFuelType,
  bulkFuelPrice: Number(formValues.bulkFuelPrice),
  bulkFuelQuantity: Number(formValues.bulkFuelQuantity),
  bulkFuelEnabled: formValues.bulkFuelEnabled
});
